module.exports = "/assets/images/melting.png";